import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useGolfHeaderStore = defineStore('golf-header', () => {
  const searchQuery = ref('')
  const title = ref('')
  const searchPlaceholder = ref('Search...')
  const showSearch = ref(false)
  const useCustomHeader = ref(false)

  const setSearchQuery = (query: string) => {
    searchQuery.value = query
  }

  const setCustomHeader = (val: boolean) => {
    useCustomHeader.value = val
    if (!val && typeof document !== 'undefined') {
      const portal = document.getElementById('golf-header-portal')
      if (portal) {
        portal.innerHTML = ''
      }
    }
  }

  const setHeaderInfo = (
    newTitle: string,
    newShowSearch: boolean,
    placeholder = 'Search...'
  ) => {
    title.value = newTitle
    showSearch.value = newShowSearch
    searchPlaceholder.value = placeholder
    searchQuery.value = '' // Clear search when navigating to a new page
  }

  return {
    searchQuery,
    title,
    searchPlaceholder,
    showSearch,
    useCustomHeader,
    setSearchQuery,
    setCustomHeader,
    setHeaderInfo,
  }
})
